(function() {

    angular
        .module('ngmvac')
        .value('duScrollOffset', 200)
        .value('fontNames', {
			'1-62' : 'fa fa-bed', //Cama individual de 90 a 130 de ancho
			'1-85' : 'fa fa-thumbs-o-up', //Gay-friendly
			'10-100' : 'fa fa-building', //1
			'10-20' : 'fa fa-building-o', //Hotel
			'10-30' : 'fa fa-cc-amex', //American Express
			'10-40' : 'fa fa-university', //Centro ciudad
			'10-60' : 'fa fa-bath', //Baño
			'10-70' : 'fa fa-snowflake-o', //Aire acondicionado en zonas comunes
			'100-10' : 'fa fa-building', //Suites
			'100-60' : 'icon-internet-explorer', //Acceso a internet
			'100-70' : 'icon-grocery', //Supermercado
			'100-80' : 'fa fa-list-alt', //Cena de menú a elegir
			'11-70' : 'fa fa-fire', //Chimenea
			'11-80' : 'fa fa-cutlery', //Desayuno y cena
			'110-10' : 'fa fa-building', //Apartamentos
			'110-30' : 'fa fa-credit-card-alt', //EuroCard
			'110-60' : 'fa fa-cutlery', //Pequeña cocina
			'110-70' : 'fa fa-shopping-bag', //Tienda
			'111-60' : 'icon-cup', //Utensilios de cocina, platos y tazas
			'114-80' : 'fa fa-glass', //Snacks
			'115-10' : 'fa fa-university', //Estudios
			'115-30' : 'fa fa-credit-card-alt', //Euro 6000
			'115-60' : 'fa fa-cutlery', //Cocina
			'12-70' : 'fa fa-fire-extinguisher', //Detector de humos
			'12-80' : 'icon-food', //Desayuno y comida
			'120-10' : 'fa fa-bed', //Bungalows
			'120-60' : 'icon-alcohol-shop', //Minibar
			'120-74' : 'fa fa-scissors', //Peluquería
			'123-10' : '', //Villas
			'124-10' : 'icon-disabled-wheelshair', //Habitaciones minusválidos
			'125-40' : 'icon-controll', //Zona de entretenimiento
			'125-70' : 'icon-garden', //Jardín
			'126-10' : 'fa fa-h-square', //Habitaciones triples
			'127-10' : 'fa fa-h-square', //Habitaciones cuádruples
			'128-10' : 'icon-black-tie', //Habitaciones ejecutivas
			'129-10' : 'fa fa-star-o', //Habitaciones superiores
			'130-40' : 'fa fa-trophy', //Campo de golf
			'130-60' : 'fa fa-snowflake-o', //Nevera
			'130-71' : 'fa fa-beer', //Bar
			'130-80' : 'icon-ios-nutrition', //Dietas especiales
			'130-85' : 'fa fa-plane', //Información del vuelo requerida
			'131-10' : 'fa fa-users', //Habitaciones familiares
			'132-10' : 'fa-building-o', //Habitaciones Twin
			'135-60' : 'fa fa-snowflake-o', //Mini nevera
			'135-70' : 'icon-garden', //Terraza
			'137-60' : 'fa fa-cutlery', //Horno
			'140-60' : 'fa fa-cutlery', //Microondas
			'140-73' : 'fa fa-glass', //Pub
			'143-60' : 'fa fa-coffee', //Cafetera / Tetera
			'145-40' : 'fa fa-bus', //Estación de autobuses/tren
			'145-60' : '', //Lavadora
			'147-60' : '', //Plancha con tabla
			'150-61' : 'fa fa-bed', //Cama doble de 131-150 de ancho
			'150-62' : 'fa fa-bed', //Cama doble de 131-150 de ancho
			'150-73' : 'fa fa-music', //Discoteca / club nocturno
			'155-61' : 'fa fa-bed', //cama king size 150-183 ancho
			'155-62' : 'fa fa-bed', //cama king size 150-183 ancho
			'160-20' : 'fa-building-o', //Hostal
			'160-40' : 'fa fa-road', //pistas de esqui
			'160-60' : 'fa fa-bookmark-o', //moqueta
			'160-73' : 'fa fa-volume-up', //Teatro/ auditorio
			'160-80' : 'fa fa-coffee', //desayuno para madrugadores
			'160-90' : 'fa fa-users', //banana boat
			'170-60' : 'fa fa-snowflake-o', //aire acondicionado central
			'170-72' : 'icon-easel', // sala de conferencias
			'170-80' : 'fa fa-cutlery', //Desayuno tardio
			'170-90' : '', //Esqui Acuátioco
			'180-60' : 'fa fa-snowflake-o', //aire acondicionado individual
			'180-73' : 'fa fa-money', //Casino
			'180-80' : 'icon-food', //Desayuno Caliente
			'180-90' : '', //Motos acuáticas
			'190-60' : 'fa fa-thermometer-empty', //calefaccion central
			'190-73' : 'fa fa-gamepad', //Sala de juegos
			'190-90' : 'fa fa-ship', //Ir en barco a motor
			'192-73' : 'fa fa-television', //sala de television
			'193-73' : 'fa fa-television', //sala de television
			'195-60' : 'fa fa-thermometer-empty', //Calefaccion individual
			'2-85' : 'fa fa-address-card', //Nudista
			'20-10' : 'calendar', //Año de construcción
			'20-100' : 'icon-number-two', //2
			'20-30' : '', //EC
			'20-40' : 'fa fa-bus', //Parada de bus/metro más cercana
			'20-60' : 'fa fa-shower', //Ducha
			'200-60' : 'fa fa-shield', //Caja fuerte
			'200-71' : 'fa fa-cutlery', //Restaurante
			'200-80' : 'icon-coffee-1', //Desayuno servido
			'200-90' : 'icon-diving', //Buceo
			'203-85' : 'fa fa-male', //Sólo adultos
			'210-70' : 'fa fa-key', //Recogida de llaves
			'210-80' : 'fa fa-shopping-basket', //Picnic
			'210-90' : '', //Windsurf
			'220-20' : 'icon-lodging', //Lodge
			'220-60' : 'fa fa-map-signs', //Sala de estar
			'220-71' : 'icon-no-smoking-1', //Zona no fumador
			'220-80' : 'icon-coffee-1', //Brunch
			'220-90' : 'fa fa-fire', //Vela
			'225-71' : 'icon-cigarette', //Zona fumadores
			'230-60' : '', //Balcón
			'230-71' : '', //Trona
			'230-80' : 'fa fa-cutlery', //Comidas sin gluten 
			'230-90' : '', //Navegar en catamarán
			'240-60' : 'icon-garden', //Terraza
			'240-70' : 'fa fa-mobile', //Cobertura teléfonos móviles
			'240-80' : 'fa fa-ban', //No se ofrece alcohol
			'240-90' : '', //Canoa
			'25-20' : 'icon-building-o', //Aparthotel
			'250-20' : 'icon-campfire', //Camping
			'250-60' : 'fa fa-wheelchair', //Accesible para personas de movilidad reducida
			'250-70' : 'icon-internet-explorer', //Internet por cable
			'250-80' : 'icon-ios-nutrition', //Comida vegetariana
			'250-90' : '', //Bote a pedales
			'251-80' : 'icon-ban', //Media pensión sin bebidas
			'252-80' : 'fa fa-coffee', //Media pensión con bebidas sin alcohol
			'253-80' : 'fa fa-coffee', //Media pensión con bebidas
			'254-80' : 'fa fa-ban', //Pensión completa sin bebidas
			'255-80' : 'fa fa-coffee', //Pensión completa con bebidas sin alcohol
			'256-80' : 'fa fa-coffee', //Pensión completa con bebidas
			'257-80' : 'fa fa-ban', //Todo incluido sin bebidas
			'258-80' : 'fa fa-coffee', //Todo incluido con bebidas sin alcohol
			'259-80' : 'fa fa-beer', //Todo incluido con bebidas con alcohol (marca propia)
			'260-20' : 'fa fa-wheelchair', //Botel
			'260-60' : 'icon-disabled', //Baño para personas de movilidad reducida
			'260-70' : 'fa fa-clock-o', //Hora de entrada
			'260-80' : 'fa fa-beer', //Todo incluido con bebidas con alcohol (primeras marcas)
			'260-90' : 'icon-tennis', //Tenis de mesa
			'261-60' : 'fa fa-wifi', //Wi-fi
			'261-80' : '', //Pensión completa
			'262-60' : 'fa fa-clock-o', //Servicio despertador
			'262-80' : '', //Media pensión
			'263-60' : 'fa fa-list-alt', //Almohadas a la carta
			'263-80' : 'fa fa-plus"', //Todo incluido
			'264-60' : 'icon-child', //Cuna bajo petición
			'264-80' : 'fa fa-list-alt', //Desayuno a la carta
			'265-60' : 'fa fa-bluetooth', //Altavoz bluetooth
			'265-80' : 'icon-fork-and-spoon', //cena de gala
			'266-60' : '', //Servicio de buenas noches
			'268-60' : 'fa fa-plug', //Electricidad 220v
			'269-60' : 'fa fa-bath', //bañera hidromasage
			'270-20' : 'icon-ship', //Crucero
			'270-60' : 'fa fa-music', //Reproductor de CD's 
			'270-70' : 'icon-building-o', //Servicio de habitaciones
			'270-90' : 'icon-tennis', //Squash
			'271-60' : 'fa fa-film', //Reproductor de DVDs
			'272-60' : 'fa fa-film', //peliculas de pago
			'273-60' : 'fa fa-clock-o', //Reloj Despertador
			'274-60' : 'icon-playstation', //Video consola
			'275-60' : 'fa fa-bed', //Camas supleatorias bajo peticion
			'276-60' : 'fa fa-shower', //Kit de baño
			'277-60' : 'fa fa-music', //hilo musical
			'279-60' : '', //Escritorio
			'280-60' : '', //Albornoz
			'280-70' : 'icon-tshirt', //Servicio de lavandería
			'280-90' : 'icon-pitch', //Aeróbic
			'281-60' : 'icon-shoe', //Zapatillas
			'282-60' : 'icon-mirror', //Espejo de aumento
			'283-60' : '', //Plancha de pantalones
			'284-61' : 'icon-sofa-cama', //Sofá-cama
			'284-62' : 'icon-sofa-cama', //Sofá-cama
			'285-60' : 'icon-gift', //Kit de bienvenida
			'285-70' : 'icon-tshirt', //Lavandería
			'286-60' : 'icon-air', //Ventilador
			'287-60' : 'icon-cigarette', //Habitaciones para fumadores
			'288-60' : 'icon-satellite-ground', //TV via satelite
			'289-60' : 'fa fa-television', //TV por cable
			'290-60' : '', //Lavavajillas
			'290-70' : 'fa fa-user-md', //servicio medico
			'292-60' : 'fa fa-plug', //adaptador de enchufe
			'293-60' : 'fa fa-list-alt', //Toallas a la carta
			'294-61' : 'fa fa-bed', //Cama Queen size de 150 a 154 de ancho
			'294-62' : 'fa fa-bed', //Cama Queen size de 150 a 154 de ancho
			'295-60' : 'icon-building-o', //Superficie habitación (m²)
			'295-70' : 'fa fa-wheelchair', //Accesible para personas de movilidad reducida
			'295-90' : 'icon-barbell', //Gimnasia
			'296-60' : 'icon-home-3', //Chimenea
			'297-60' : '', //Detector de humos
			'298-60' : 'fa fa-hashtag', //Numero de dormitorios
			'299-60' : 'fa fa-shower', //Baño compartido
			'3-85' : 'icon-ban', //No se permiten despedidas de soltero/a ni otras celebraciones
			'30-10' : 'icon-calendar', //Año de última reforma
			'30-100' : 'icon-number-three', //3
			'30-20' : 'icon-parking-sign', //Apartamento
			'30-30' : '', //JCB
			'30-60' : 'fa fa-bath', //Bañera
			'30-70' : 'icon-clock', //Recepción 24h
			'30-80' : 'icon-desayuno', //Desayuno buffet
			'300-20' : 'icon-parking-sign', //Condominio o apartamento vacacional
			'300-60' : 'icon-broom', //Servicio de limpieza
			'300-70' : 'icon-android-bicycle', //Espacio para bicicletas
			'300-90' : '', //Tiro con arco
			'301-60' : 'icon-air', //Oxígeno enriquecido
			'302-60' : 'icon-bed', //Los niños comparten la cama con sus padres
			'303-60' : 'icon-vhome-1', //Habitación insonorizada
			'304-60' : 'icon-call-old-telephone', //Teléfono en el cuarto de baño
			'305-60' : 'fa fa-bath', //Bañera de hidromasaje
			'306-60' : 'icon-swimming', //Piscina exterior
			'307-60' : '', //Sauna
			'308-60' : 'icon-school', //Sala de fitness
			'309-60' : '', //Billar
			'310-20' : 'icon-home', //Casa o chalet vacacional
			'310-60' : '', //Baño Turco
			'310-70' : 'icon-bicycle', //Alquiler de bicicletas
			'310-90' : 'icon-android-bicycle', //Equitación
			'311-60' : 'icon-tennis', //Tenis de mesa
			'312-60' : '', //Solarium
			'313-60' : 'icon-swimming', //Piscina interior
			'314-60' : 'icon-garden', //Jardín
			'315-60' : 'icon-controll', //Sala de juegos
			'316-60' : '', //Dardos
			'317-60' : 'icon-controll', //Área de juegos
			'318-60' : 'icon-data', //Tostadora
			'319-60' : 'icon-data', //Horno
			'320-20' : '', //Chalet adosado vacacional
			'320-60' : 'icon-cutlery', //Comedor
			'320-70' : 'icon-parking-sign', //Aparcamiento
			'320-90' : 'fa fa-bicycle', //Bici carretera/montaña
			'321-60' : 'icon-tshirt', //Secadora de ropa
			'322-60' : 'icon-barbecue-eat-food-streamline', //Instalaciones para barbacoa
			'323-60' : 'icon-pitch', //Acceso a pie de pista
			'324-60' : 'icon-barbecue-eat-food-streamline', //Grill/Barbacoa
			'325-60' : '', //Guardaesquís
			'325-90' : 'fa fa-futbol-o', //Balonmano
			'326-60' : 'icon-swimming', //Piscina privada
			'327-60' : 'icon-tshirt-outline', //Toallas y ropa de cama con cargo
			'328-60' : 'icon-palm-tree', //Zona de playa privada
			'329-60' : 'icon-book', //Biblioteca
			'330-20' : 'icon-suitcase', //Complejo turístico vacacional
			'330-60' : 'icon-japan-streamline-tea', //Tetera eléctrica
			'330-70' : 'icon-parking-sign', //Garaje
			'330-90' : 'fa fa-dribbble', //Baloncesto
			'331-60' : 'icon-bicycle', //Bicicletas disponibles
			'335-90' : 'icon-dribble', //Voleibol
			'340-20' : '', //Riad
			'340-73' : 'fa fa-child', //Mini club (Niños)
			'340-90' : 'fa fa-dribbble', //Volley playa
			'35-80' : 'fa fa-cutlery', //Desayuno continental
			'350-20' : 'icon-home-4', //Motel
			'350-73' : 'fa fa-gamepad', //Área de juegos
			'350-90' : '', //Billar
			'360-20' : 'icon-bed', //Bed and breakfast
			'360-73' : 'icon-swimming', //Piscina interior de agua dulce
			'360-90' : '', //Petanca
			'361-73' : 'icon-swimming', //Piscina interior de agua salada
			'362-73' : 'icon-swimming', //Piscina interior climatizada
			'363-73' : 'icon-swimming', //Piscina exterior de agua dulce
			'364-73' : 'icon-swimming', //Piscina exterior de agua salada
			'365-73' : 'icon-swimming', //Piscina exterior climatizada
			'370-20' : 'icon-man-people-streamline-user', //Boutique
			'370-90' : '', //Bolera
			'380-20' : 'icon-commercial', //Hotel histórico de lujo
			'380-90' : 'icon-golf', //Mini golf
			'385-73' : 'icon-swimming', //Piscina infantil
			'390-20' : 'icon-home-4', //Pousada
			'390-70' : 'icon-recent-changes', //Hora de salida
			'390-90' : 'icon-golf', //Golf
			'395-73' : 'icon-sofa-cama', //Tumbonas
			'40-10' : 'icon-home', //Edificio(s) anexo(s)
			'40-100' : 'icon-number-four', //4
			'40-30' : 'icon-fast-food', //Diners Club
			'40-40' : 'icon-palm-tree', //Playa
			'40-60' : '', //Secador
			'40-70' : 'fa fa-shield', //Caja fuerte
			'40-80' : 'icon-coffee-1', //Desayuno
			'400-20' : 'icon-suitcase', //Residencia
			'400-73' : 'fa fa-umbrella', //Sombrillas
			'401-73' : 'fa fa-male', //Entretenimiento para adultos
			'405-73' : 'fa fa-child', //Animación para niños
			'410-20' : 'icon-warehouse', //Hotel rural
			'410-74' : 'fa fa-bath', //Bañera hidromasaje
			'410-90' : '', //Surf
			'420-74' : '', //Sauna
			'425-74' : 'icon-garden', //Solarium
			'430-70' : 'icon-garden', //Terraza Solarium
			'430-90' : 'icon-ios-tennisball-outline', //Tenis
			'440-74' : '', //Baño de vapor
			'440-90' : '', //Paddle
			'450-74' : 'icon-lodging', //Masajes
			'450-90' : 'icon-tennis', //Bádminton
			'460-74' : 'icon-lodging', //Tratamientos Spa
			'460-90' : '', //Dardos
			'470-70' : 'icon-barbell', //Gimnasio
			'470-90' : '', //Putting green
			'475-70' : 'fa fa-child', //Guardería
			'467-70': 'fa fa-child', //guarderia
			'480-90' : '', //Snow boarding
			'485-70' : 'icon-child', //Servicio de niñera
			'490-70' : 'icon-model-s', //Alquiler de coches
			'490-90' : '', //Esqui
			'495-70' : 'icon-car', //Servicio de traslados
			'50-10' : 'icon-arrow-combo', //Número de pisos (edificio principal)
			'50-100' : '', //5
			'50-20' : 'icon-home', //Casa de huéspedes
			'50-30' : 'fa-cc-mastercard', //MasterCard
			'50-60' : 'icon-phone-1', //Teléfono de línea directa
			'50-70' : 'icon-cash', //Cambio de moneda
			'50-80' : 'fa fa-cutlery', //Almuerzo buffet
			'500-70' : 'icon-police-1', //Aparcamiento vigilado
			'500-90' : '', //Trineo
			'505-70' : 'icon-man-people-streamline-user', //Personal multilingüe
			'510-90' : '', //Forfait
			'515-70' : 'icon-microphone', //Prensa
			'520-70' : 'icon-police-1', //Seguridad 24h.
			'520-90' : 'icon-golf', //Campo de práctica (Golf)
			'525-70' : 'icon-suitcase', //Servicio de botones
			'530-90' : '', //Safari
			'535-70' : 'icon-guide-dog', //Se admiten animales -5kg
			'540-70' : 'icon-guide-dog', //Se admiten animales +5kg
			'545-70' : 'icon-golf-1', //Recepción de golf
			'55-60' : 'icon-fa fa-television', //Televisión
			'550-70' : 'icon-wifi', //Wi-fi
			'551-85' : 'icon-cash', //Cargos por llegada tardía
			'552-85' : 'icon-date', //Check-in anticipado
			'554-85' : 'icon-date', //Salida anticipada
			'555-72': 'icon-alcohol-shop', //snack/bar junto piscina
			'555-71' : 'fa fa-glass',
			'556-70' : 'icon-call-old-telephone', //Llamadas nacionales e internacionales
			'557-85' : 'icon-card-user-2', //Identificación a la llegada
			'558-85' : 'fa fa-id-card-o', //Certificado de matrimonio obligatorio para las parejas que comparten habitación
			'559-70' : 'fa fa-bell', //Consigna
			'56-10' : 'icon-call-old-telephone', //Habitaciones comunicadas
			'560-70' : 'icon-parking-sign', //Servicio de aparcacoches
			'560-71' : 'icon-fork-and-spoon', //Sala de banquetes
			'561-85' : 'icon-card', //Depósito a la llegada
			'562-70' : 'icon-airport-plane', //Traslado al aeropuerto
			'562-85' : 'icon-no-smoking', //Establecimiento para no fumadores
			'563-85' : 'fa fa-child', //Alojamiento gratuito para niños excepto las comidas
			'564-70' : 'icon-hour-glass', //Salida tardía
			'564-85' : 'fa fa-calendar', //Edad mínima de check-in
			'565-70' : 'icon-thermometer', //Tostadora
			'565-71' : 'icon-restaurant', //Cocina en vivo
			'566-70' : 'icon-thermometer', //Horno
			'567-70' : 'icon-cutlery', //Comedor
			'568-70' : 'icon-tshirt', //Secadora de ropa
			'569-70' : 'icon-barbecue-eat-food-streamline', //Instalaciones para barbacoa
			'570-70' : 'icon-pitch', //Acceso a pie de pista
			'570-71' : 'icon-alcohol-shop', //Bar acuático
			'571-70' : 'icon-barbecue-eat-food-streamline', //Grill/Barbacoa
			'572-70' : '', //Guardaesquís
			'573-70' : 'icon-swimming', //Piscina privada
			'574-70' : 'icon-palm-tree', //Zona de playa privada
			'575-70' : 'icon-book', //Biblioteca
			'575-71' : 'fa fa-snowflake-o', //Aire acondicionado en restaurante
			'575-72' : 'icon-easel', //Sala de reuniones
			'576-70' : 'icon-expresos', //Tetera eléctrica
			'577-70' : 'icon-bike', //Bicicletas disponibles
			'578-70' : 'icon-tshirt-outline', //Toallas y ropa de cama con cargo
			'579-70' : 'icon-bicycle', //Tienda/taller de bicicletas propio del hotel
			'580-70' : 'icon-bicycle', //Tienda/taller de bicicletas colaborador asociado
			'580-71' : 'icon-coffee', //Sala de desayuno
			'580-72' : 'fa fa-desktop', //Proyector
			'590-72' : 'icon-group-full', //Azafata de congresos
			'595-72' : 'fa fa-assistive-listening-systems', //Servicio de secretariado
			'60-10' : 'icon-arrow-combo', //Número de pisos (edificio anexo)
			'60-20' : '', //Agroturismo
			'60-30' : 'icon-card-user-2', //Visa
			'60-70' : 'icon-tshirt-outline', //Guardarropa
			'60-80' : 'fa fa-list-alt', //Almuerzo a la carta
			'600-72' : 'fa fa-file-text', //Fotocopiadora
			'605-72' : 'fa fa-briefcase', //Centro de negocios
			'610-72' : 'icon-print', //Fax
			'610-73' : 'swimming', //Toboganes acuáticos
			'615-74' : '', //Salon de Belleza
			'620-72' : 'icon-printer', //Impresora
			'620-74' : 'icon-lodging', //Spa
			'630-72' : 'icon-easel', //Alquiler de equipo audiovisual
			'630-74' : '', //Baño Turco (Hamman)
			'635-75' : '', //Green Globe 21 
			'640-75' : '', //Earth Check
			'645-75' : '', //Travelife
			'650-75' : '', //Green Star
			'655-75' : '', //Rainforest Alliance
			'660-75' : '', //Biosphere Certification - Responsible Tourism Institute (ITR)
			'670-76' : '', //EMAS
			'675-76' : '', //EU Ecolabel
			'695-76' : '', //Austrian Ecolabel (Umweltzeichen für Tourismusbetriebe) 
			'70-10' : '', //Número total de habitaciones
			'70-20' : '', //Resort
			'70-40' : '', //Puerto
			'70-70' : 'fa fa-arrows-v', //Ascensor
			'70-80' : 'fa fa-list-alt', //Almuerzo de menú
			'71740-76' : '', //ECO Certification Malta 
			'741-76' : '', //TourCert
			'755-77' : '', //CST – Costa Rica 
			'80-10' : 'icon-bed', //Habitaciones individuales
			'80-30' : '', //Maestro
			'80-40' : 'icon-fa fa-plane', //Aeropuerto
			'80-60' : 'icon-connected-object', //Radio
			'80-71' : 'fa fa-coffee', //Cafetería
			'80-80' : 'fa fa-cutlery', //Cena Buffet
			'810-78' : '', //EcoCertification (EA) – Australia
			'830-79' : '', //FTTSA – South Africa 
			'840-75' : '', //ISO  9001 certified hotels and restaurants
			'845-75' : '', //ISO  14001 certified hotels and restaurants
			'90-10' : 'icon-bed', //Habitaciones dobles
			'90-30' : '', //Visa Electrón
			'90-60' : 'icon-connected-object', //Estéreo
			'90-70' : 'icon-micro-record-streamline', //Stand de prensa
			'90-80' : 'icon-food', //Cena a la carta
			'90-90' : 'icon-barbell', //Gimnasia acuática
			'95-10' : '', //Junior Suites
			'992-61' : 'icon-bed-1', //Camas plegables bajo petición
			'992-62' : 'icon-bed-1', //Camas plegables bajo petición
			'993-61' : 'icon-bed-1', //Literas
			'993-62' : 'icon-bed-1', //Literas
			'995-60' : 'icon-no-smoking', //NO Habitaciones para fumadores
			'997-60' : 'icon-ban', //NO Baño para minusválidos
			'998-10' : 'icon-call-old-telephone', //SI Habitaciones comunicadas
			'999-70' : 'icon-ban' //NO Accesible para minusválidos
		})
        .value('CurrencyDictionary', {
        	'USD': '$',
        	'EUR': '€',
        	'GBP': '£',
        	'MXN': '$'
        });

})();
